import React from 'react'
import SEO from '../../../utils/Seo';

const Blog = () => {
  return (
    <>
      <SEO
        title="Blog - MyAd360 | Ad Monetization Tips & Industry News"
        description="Stay updated with expert tips, Google AdX strategies, and ad revenue growth guides on the MyAd360 blog."
        keywords="ad tech blog, monetization strategies, Google AdX tips, header bidding tutorials"
      />
    </>
  )
}

export default Blog;
